import { useState } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { filterBy } from "@progress/kendo-data-query";
import { columnTypes } from "./AdminGrid";
import styles from "./AdminGrid.module.css";
import { IsActiveFilterCell } from "./CustomBooleanFilterCells";

export default function AdminGridKendo(props) {
  const [page, setPage] = useState({ skip: 0, take: 10 });
  const pageChange = (event) => {
    setPage(event.page);
  };
  const {
    columns,
    data,
    sortable,
    sort,
    sortChange,
    filter,
    filterChange,
    filterOperators,
    isFilterable,
  } = props;

  const onFilterChange = (e) => {
    filterChange(e.filter);
    setPage({ skip: 0, take: page.take });
  };

  const getColumn = (c, key, headerColumnChecked) => {
    let column;
    if (c.type === columnTypes.actions) {
      column = (
        <Column
          key={key}
          title={c.title}
          field={c.field}
          filterable={false}
          sortable={c.sortable == undefined ? true : c.sortable}
          cell={(props) => (
            <td>
              {props.dataItem[c.field].map((action, actionKey) => (
                <button
                  className={styles.actionButton}
                  key={actionKey}
                  aria-label={action.label}
                  onClick={() => action.onClick(props)}
                >
                  {action.title}
                </button>
              ))}
            </td>
          )}
        />
      );
    } else if (c.type === columnTypes.checkbox) {
      column = (
        <Column
          key={key}
          title={c.title}
          filterable={false}
          sortable={c.sortable == undefined ? true : c.sortable}
          headerCell={() => (
            <label>
              <input
                type="checkbox"
                checked={headerColumnChecked}
                aria-label={c.ariaLabelForHeaderCheckbox}
                onChange={() =>
                  c.onChange({ column: c, page, data, headerColumnChecked })
                }
              />
              {c.title}
            </label>
          )}
          cell={(props) => {
            const { value, onChange } = props.dataItem[c.field];
            const ariaLabel = c.ariaLabelledByField
              ? `${c.title} checkbox for ${
                  props.dataItem[c.ariaLabelledByField]
                }`
              : undefined;
            return (
              <td>
                <input
                  type="checkbox"
                  checked={value}
                  onChange={() => onChange(props)}
                  aria-label={ariaLabel}
                />
              </td>
            );
          }}
        />
      );
    } else if (c.type === columnTypes.boolean) {
      column = (
        <Column
          key={key}
          title={c.title}
          field={c.field}
          filterCell={c.filterCell}
          sortable={c.sortable == undefined ? true : c.sortable}
          cell={(props) => {
            const value = props.dataItem[c.field];
            const ariaLabel = c.ariaLabelledByField
              ? `${c.title} check for ${props.dataItem[c.ariaLabelledByField]}`
              : undefined;
            return value ? (
              <td>
                <div>
                  <i aria-hidden="true" className="fa fa-check" style={{ marginLeft: "0px" }} title="Checked"></i>
                  <span className="sr-only">Checked</span>
                </div>
              </td>
            ) : (
              <td>
                <div aria-label="Unchecked" title="Unchecked"></div>
              </td>
            );
          }}
        />
      );
    } else if (c.type === columnTypes.radioButton) {
      column = (
        <Column
          key={key}
          title={c.title}
          filterable={false}
          sortable={c.sortable == undefined ? true : c.sortable}
          cell={(props) => {
            const { value, onChange } = props.dataItem[c.field];
            const ariaLabel = c.ariaLabelledByField
              ? `${c.title} radio for ${props.dataItem[c.ariaLabelledByField]}`
              : undefined;
            return (
              <td>
                <input
                  type="radio"
                  name="singleSelectionGroup"
                  checked={value}
                  onChange={() => onChange(props)}
                  onClick={() => onChange(props)}
                  aria-label={ariaLabel}
                />
              </td>
            );
          }}
        />
      );
    } else {
      column = (
        <Column
          key={key}
          field={c.field}
          title={c.title}
          sortable={c.sortable == undefined ? true : c.sortable}
          filterable={c.isFilterable !== undefined ? c.isFilterable : false}
          filterCell={c.filterCell}
        />
      );
    }
    return column;
  };

  const filteredData = filterBy(data, filter);
  const pageData = filteredData.slice(page.skip, page.skip + page.take);

  let headerColumnChecked = true;
  let checkboxColumn = null;
  const checkBoxColumns = columns.filter(
    (c) => c.type === columnTypes.checkbox
  );
  if (checkBoxColumns.length > 0) {
    checkboxColumn = checkBoxColumns[0];
  }

  if (checkboxColumn) {
    for (let i = 0; i < pageData.length; i++) {
      if (!pageData[i][checkboxColumn.field].value) {
        headerColumnChecked = false;
        break;
      }
    }
  }

  if (pageData.length === 0) headerColumnChecked = false;

  return (
    <Grid
      data={pageData}
      skip={page.skip}
      take={page.take}
      total={filteredData.length}
      pageable={{ pageSizes: [5, 10, 25, 50] }}
      onPageChange={pageChange}
      sortable={sortable}
      sort={sort}
      onSortChange={sortChange}
      filterOperators={filterOperators}
      filterable={isFilterable != undefined ? isFilterable : false}
      filter={filter}
      onFilterChange={onFilterChange}
    >
      {columns.map((c, key) => getColumn(c, key, headerColumnChecked))}
    </Grid>
  );
}
